/*
 * Copyright (c) 2023.
 * @FileName: index
 * @FilePath: src/utils/request/interceptors
 * @Description:
 * @Project: kerastase_2022_member-center_wx-mp_frontend
 * @Author: lunazhou
 * @Date: 2023/2/2 19:34
 * @LastEditors: lunazhou
 * @LastEditTime: 2023/2/2 19:34
 */
import requestInterceptor from './request-interceptor';
import responseInterceptor from './response-interceptor';

const interceptors = {
  requestInterceptor,
  responseInterceptor,
};

export default interceptors;
